var defaultConfig = {
  defaultLanguage: 'en',
  apiUrl: '/',
  charity: false,
  configUrl: '/config.json',
  sessionKeyAuth: 'IBE_AUTH',
  sessionKeyApp: 'IBE_APP',
  sessionKeyCookieLaw: 'IBE_COOKIES',
  googleApiKey: '',
  googleAnalyticsTrackingId: null,
  googleTagManagerContainerId: null,
  session: {
    expirationTimeNotificationOffset: 1000 * 60
  },
  fadeOutAnimationOffset: 0.5
};

export { defaultConfig as default };
//# sourceMappingURL=defaultConfig.js.map
